import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../../styles/LLMember/1ChooseMember.css';

function FrameSelectionLLMember() {
  const navigate = useNavigate();
  const [selectedFrame, setSelectedFrame] = useState(null);

  // Frame options with their corresponding overlays and frame images
  const frameOptions = [
    {
      id: 'soobin',
      name: 'SOOBIN',
      frameImage: '/img/LLMember/SB.png',
      overlays: ['SB1.png', 'SB2.png', 'SB3.png', 'SB4.png'],
    },
    {
      id: 'yeonjun',
      name: 'YEONJUN',
      frameImage: '/img/LLMember/YJ.png',
      overlays: ['YJ1.png', 'YJ2.png', 'YJ3.png', 'YJ4.png'],
    },
    {
      id: 'beomgyu',
      name: 'BEOMGYU',
      frameImage: '/img/LLMember/BG.png',
      overlays: ['BG1.png', 'BG2.png', 'BG3.png', 'BG4.png'],
    },
    {
      id: 'taehyun',
      name: 'TAEHYUN',
      frameImage: '/img/LLMember/TH.png',
      overlays: ['TH1.png', 'TH2.png', 'TH3.png', 'TH4.png'],
    },
    {
      id: 'hueningkai',
      name: 'HUENINGKAI',
      frameImage: '/img/LLMember/HK.png',
      overlays: ['HK1.png', 'HK2.png', 'HK3.png', 'HK4.png'],
    }
  ];

  const handleFrameSelect = (frame) => {
    setSelectedFrame(frame);
  };

  const handleContinue = () => {
    if (selectedFrame) {
      navigate('/photobooth/LLMember', { 
        state: { 
          selectedFrame: selectedFrame,
          frameImage: selectedFrame.frameImage,
          overlays: selectedFrame.overlays
        } 
      });
    }
  };

  return (
    <div className="frame-selection-container">
      {/* Back link to welcome page */}
      <Link to="/" className="frame-back-link">
        ← Back to Home
      </Link>

      <h2 className="frame-selection-title">
        Please choose a frame
      </h2>
      
      <div className="frame-selection-grid">
        {frameOptions.map((frame) => (
          <div key={frame.id} className="frame-container">
            <div 
              className={`frame-option ${selectedFrame?.id === frame.id ? 'selected' : ''}`}
              onClick={() => handleFrameSelect(frame)}
            >
              <div className="frame-image-container">
                <img
                  src={frame.frameImage}
                  alt={frame.name}
                  className="frame-image"
                  onError={(e) => {
                    console.error(`Failed to load image: ${frame.frameImage}`);
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />

                {/* Fallback if image doesn't load */}
                <div className="frame-fallback" style={{ display: 'none' }}>
                  {frame.name}
                </div>
              </div>
            </div>
            
            {/* Frame name below the entire frame option */}
            <div className="frame-name">
              {frame.name}
            </div>
          </div>
        ))}
      </div>

      {/* Continue button */}
      <div className="frame-continue-section">
        <button
          onClick={handleContinue}
          disabled={!selectedFrame}
          className="frame-continue-button"
        >
          Next &gt;
        </button>
      </div>
    </div>
  );
}

export default FrameSelectionLLMember;
